
import { combineReducers } from 'redux';

import auth from '../common/client/reducers/auth';
import operationStatus from '../common/client/reducers/operationStatus';

import analyze from './analyze';
import analyze2opsub from './analyze2opsub';
import analyzeDefunctPar from './analyzeDefunctPar';
import drupoz from './drupoz';
import iskn from './iskn';
import isknActual from './isknActual/';
import isknExplorer from './isknExplorer';
import info from './info';
import katuze from './katuze';
import map from './map';
import opsub from './opsub';
import parHistory from './parHistory';
import project from './project';
import projectList from './projectList';
import search from './search';
import tel from './tel';
import vla from './vla';

/*
import app from './app';
*/

export default combineReducers({
    analyze2opsub,
    analyzeDefunctPar,
    auth,
    operationStatus,
    drupoz,
    iskn,
    isknActual,
    isknExplorer,
    map,
    vla,
    analyze: analyze(),
    katuze: katuze(),
    info: info(),
    opsub: opsub(),
    parHistory: parHistory(),
    project: project(),
    projectList: projectList(),
    search: search(),
    tel: tel(),
});
